
<div class="bmc-sync-data__wrapper">

  <div class="bmc-syncdata-import-step1" [ngClass]="errorMessage ? 'bmc-syncdata-import-step1--error' : ''">
    <h2 class="bmc-syncdata-import-step1__title">{{'SYNC_DATA.SELECT_ENTITY_VALUES_TO_IMPORT' | translate}}</h2>
    <label class="bmc-syncdata-import-step1__subtitle">{{'SYNC_DATA.CHOOSE_ENTITIES_DO_YOU_NEED_TO_IMPORT' | translate}}</label>
    <div class="bmc-syncdata-import-step1__table">
      <div class="bmc-syncdata-import-step1__container bmc-syncdata-import-step1__container--left">
        <div class="bmc-syncdata-import-step1__container__title bmc-syncdata-import-step1__container__title--left">
          <label class="bmc-syncdata-import-step1__container__title__text">&nbsp;&nbsp;{{ 'SYNC_DATA.AVAILABLE_ENTITY_VALUES' | translate}}</label>
        </div>
        <div>
          <div class="bmc-syncdata-import-step1__container__search-box">

            <svg class="bz-icon-svg bz-icon-svg--16 bmc-syncdata-import-step1__container__search-box__icon">
              <use href="#icon-search"></use>
            </svg>
            <input class="bmc-syncdata-import-step1__container__search-box__text" type="text" placeholder="{{ 'SYNC_DATA.SEARCH' | translate}}" #filterUnselected (input)="onSearchChange(filterUnselected.value, filterSelected.value)">
          </div>
          <ul class="bmc-syncdata-import-step1__container__list">
            <li *ngFor="let item of unselectedTables; let i = index" class="bmc-syncdata-import-step1__checkbox-item">
              <div class="bz-checkbox">
                <bzg-checkbox id="checkavailable{{i}}" [checked]="item.SelectedUI" (click)="changeSelected(item, $event)">
                  &nbsp;&nbsp;{{item.DisplayName}}
                </bzg-checkbox>
              </div>
            </li>
          </ul>
        </div>
        <div class="bmc-syncdata-import-step1__counters bmc-syncdata-import-step1__counters--left">{{itemsSelectedLeft}} {{'SYNC_DATA.ITEMS_COUNT' | translate}}</div>
      </div>
      <div class="bmc-syncdata-import-step1__buttons-cell">

        <bzg-button-primary class="bmc-syncdata-import-step1__buttons-cell__item" type="button"
                            (click)="refreshList(true, filterUnselected.value, filterSelected.value);" >
          <svg class="bz-icon-svg bz-icon-svg--16">
            <use href="#chevron-right"></use>
          </svg>
        </bzg-button-primary>

        <bzg-button-primary class="bmc-syncdata-import-step1__buttons-cell__item" type="button" (click)="refreshList(false, filterUnselected.value, filterSelected.value);">
          <svg class="bz-icon-svg bz-icon-svg--16">
            <use href="#chevron-left"></use>
          </svg>
        </bzg-button-primary>


        <bzg-button-primary class="bmc-syncdata-import-step1__buttons-cell__item" type="button" (click)="moveAll(true, filterUnselected.value, filterSelected.value);">
          <svg class="bz-icon-svg bz-icon-svg--16">
            <use href="#icon-arrow-end-right"></use>
          </svg>
        </bzg-button-primary>


        <bzg-button-primary class="bmc-syncdata-import-step1__buttons-cell__item" type="button" (click)="moveAll(false, filterUnselected.value, filterSelected.value);">
          <svg class="bz-icon-svg bz-icon-svg--16">
            <use href="#icon-arrow-end-left"></use>
          </svg>
        </bzg-button-primary>


      </div>
      <div class="bmc-syncdata-import-step1__container bmc-syncdata-import-step1__container--right">
        <div class="bmc-syncdata-import-step1__container__title bmc-syncdata-import-step1__container__title--right">
          <label class="bmc-syncdata-import-step1__container__title__text">&nbsp;&nbsp;{{ 'SYNC_DATA.ENTITY_VALUES_TO_IMPORT' | translate}}</label>
        </div>
        <div class="bmc-syncdata-import-step1__container__search-box">

          <svg class="bz-icon-svg bz-icon-svg--16 bmc-syncdata-import-step1__container__search-box__icon">
            <use href="#icon-search"></use>
          </svg>

          <input class="bmc-syncdata-import-step1__container__search-box__text" type="text" placeholder="{{ 'SYNC_DATA.SEARCH' | translate}}" #filterSelected (input)="onSearchChange(filterUnselected.value, filterSelected.value)">
        </div>
        <ul class="bmc-syncdata-import-step1__container__list">
          <li *ngFor="let item of selectedTables; let i = index" class="bmc-syncdata-import-step1__checkbox-item">
            <div class="bz-checkbox" [ngClass]="item.SelectedUI ? 'checkboxContainerSelected' : 'bmc-checkbox-container'" >
              <bzg-checkbox [checked]="item.SelectedUI" (click)="changeSelected(item, $event)">
                &nbsp;&nbsp;{{item.DisplayName}}
              </bzg-checkbox>
            </div>
          </li>
          <div class="bmc-syncdata-import-step1__counters bmc-syncdata-import-step1__counters--right">{{itemsSelectedRight}} {{'SYNC_DATA.ITEMS_COUNT' | translate}}</div>

        </ul>

      </div>
    </div>
    <div *ngIf="errorMessage" class="bmc-sync-data__error">
      <svg class="bz-icon-svg bz-icon-svg--16 bmc-sync-data__error__icon">
        <use href="#icon-warning"></use>
      </svg>
      <label class="bmc-sync-data__error__label">{{ errorMessage | translate }}</label>
    </div>
  </div>
  <div  *ngIf="isLoading"  class="bmc-sync-data__loader">
      <bounce>
        {{'SYNC_DATA.LOADING_FILE' | translate}}
      </bounce>
    </div>
</div>
